import { yupResolver } from "@hookform/resolvers/yup";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { Resolver, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { handleError } from "../../../shared/functions/handleError";
import { IUserAction } from "../../../shared/interfaces/user/IUser";
import { UserService } from "../service";
import { userSchema } from "./UserCreate";
import UserForm from "./UserForm";

const UserUpdate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<IUserAction>({
    resolver: yupResolver(userSchema, {
      context: { isCreate: false },
    }) as unknown as Resolver<IUserAction>,
    defaultValues: async () =>
      (await UserService.getSingle(Number(id))
        .then((response) => {
          return {
            ...response,
          };
        })
        .catch(handleError)) as unknown as IUserAction,
  });
  console.log(errors, "errors");
  const submitHandler = (formData: IUserAction) => {
    UserService.update(formData, Number(id))
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t("toasts.successfullyUpdated", { title: formData?.displayName }),
            {
              variant: "success",
            },
          );
        }
      })
      .catch(handleError);
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <UserForm isUpdate control={control} watch={watch} />
    </form>
  );
};

export default UserUpdate;
